/**
 * Reference slider – Swiper na obrázcích referencí.
 *
 * Na stránce je víc referencí, každá má vlastní .reference-swiper,
 * takže inicializujeme všechny. Swiper je globál z vendor bundle.
 */
function initReferenceSliders() {
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll('.reference-swiper').forEach((el) => {
        // Na stránce je víc referencí — navigaci hledáme uvnitř obalu TÉTO instance,
        // jinak by tlačítka ovládala cizí slider.
        const host = el.parentElement;

        new Swiper(el, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            grabCursor: true,
            mousewheel: {
                forceToAxis: true, // jen vodorovné gesto (2 prsty doleva/doprava)
            },
            watchOverflow: true,
            navigation: {
                nextEl: host?.querySelector('.slider-nav--next') || null,
                prevEl: host?.querySelector('.slider-nav--prev') || null,
            },
            breakpoints: {
                820: { spaceBetween: 24 },
            },
        });
    });
}

document.addEventListener('DOMContentLoaded', initReferenceSliders);
